export default {
    application: '/goodhome-zgloszenie',
    successPage: '/goodhome-dziekujemy',
};
